import React from 'react';

import { FilterResult } from '../../Types';
import ProductSlider from '../ProductSlider/ProductSlider';
import ProductOverviewComponent from './ProductOverviewComponent';
import Spinner from '../../../Spinner/Spinner';

import './Products.scss';

declare global {
    interface Window {
        __GGCareStepName: string;
    }
}

interface Props {
    recommendedProducts: FilterResult[];
    notRecommendedProducts: FilterResult[];
    isLoading: boolean;
}

export default function FilteredProducts(props: Props) {
    if (props.isLoading) {
        return (
            <div className="product-list product-list--grid product-list--loading">
                <Spinner highPerformance={false} />
            </div>
        );
    }
    return (
        <>
            <div className="product-list product-list--grid">
                <h2 className="product-list__headline">Hautbildgerechte Produkte</h2>
                {props.recommendedProducts.length > 0 ? (
                    <div className="product-list__products">
                        {props.recommendedProducts.map((product) => (
                            <ProductOverviewComponent key={product.articleNumber} product={product} />
                        ))}
                    </div>
                ) : (
                    <p>Es wurden keine hautbildgerechten Produkte gefunden</p>
                )}
            </div>

            {props.notRecommendedProducts.length > 0 ? (
                <ProductSlider
                    headline={'Weitere Produkte aus ' + window.__GGCareStepName}
                    products={props.notRecommendedProducts}
                    reloadOnUpdate={false}
                />
            ) : null}
        </>
    );
}
